import { useSessionDetailModal } from '../screens/order/session-detail-modal';

function useSessionDetailWorkflow() {
  const { prepareSessionDetailModal, showSessionDetailModal } =
    useSessionDetailModal();

  async function prepare({ address, updateOrders }) {
    await prepareSessionDetailModal({ address, updateOrders });
  }

  async function show({ prepareOnPreConfirm, prepareOnPreDeny }) {
    const result = await showSessionDetailModal({
      prepareOnPreConfirm,
      prepareOnPreDeny,
    });
    return result;
  }

  return {
    prepareSessionDetailWorkflow: prepare,
    showSessionDetailWorkflow: show,
  };
}

export { useSessionDetailWorkflow };
